var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.params),function(param){return _c('EditableTextParameter',{key:param.name,staticClass:"no-gutters",attrs:{"device_id":_vm.device._id,"param":param,"device_type":_vm.device.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }